<template>
    <div class="
        banner_slider
        {mb:50}_.slick-dotted.slick-slider
        {bottom:-50}_.slick-dots
        {w:10;h:10;mx:20}_.slick-dots_li
        {w:10;h:10;p:0}_.slick-dots_li_button
        {content:'';w:10;h:10;rounded;bg:gray300;opacity:1}_.slick-dots_li_button::before
        {opacity:1;bg:y500}_.slick-dots_li.slick-active_button::before
    ">
        <div ref="container">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
    const container = ref();

    onMounted(() => $(container.value).slick({ arrows: false, autoplay: true, dots: true }));
</script>
